import React, { useState, useEffect } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useApi } from "../../../utils/useApi";

const AddIssueModal = ({ isOpen, onClose, editStatusChanged }) => {
  const userData = JSON.parse(localStorage.getItem("yostelPG-userData"));

  console.log("userDATA123", userData);

  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onChange", // Validates on change
    defaultValues: {
      issueByUserId: userData._id,
      issueTitle: "", // Provide default values for all fields
      issueType: "",
    },
  });
  // const { data, error, loading } = useApi();

  const [load, setLoad] = useState(false);
  const [building, setBuilding] = useState([]);
  const [floor, setFloor] = useState([]);
  const [floorNumber, setFloorNumber] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [buildingId, setBuildingId] = useState("");
  const [bed, setBed] = useState([]);

  const closeAddIssueModal = () => {
    onClose();
    reset();
  };

  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuilding(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleBed = (id) => {
    const myData = {
      roomId: id,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get-beds-by-room-id`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("----beds array-->", response.data.data);
        setBed(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getFloors = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_floors_by_building/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setFloor(response.data.data.floorDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getConfiguredRoomByBuilding = (floorNumber) => {
    console.log("------>", floorNumber, buildingId);

    setFloorNumber(floorNumber);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_configured_room_by_building/${buildingId}/${floorNumber}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setRooms(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onHandleAddIssue = (data) => {
    // do the necessary api calls

    console.log(data);
    setLoad(true); //start loadings
    const myData = {
      ...data,
      issueByUserId: userData?.id,
    };

    console.log("My Data: ", myData);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/issues/create-issue`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        setLoad(false);
        editStatusChanged();
        closeAddIssueModal();
      })
      .catch((error) => {
        console.log(error);
        setLoad(false);
        toast.error(error.response.data.message);
        closeAddIssueModal();
      });

    // close the modal
  };

  useEffect(() => {
    fetchAllBuildings();
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50  backdrop-blur-sm">
      <div className="relative h-[31rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
        {/* Modal Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Add Issue</h2>
          <AiFillCloseCircle
            onClick={closeAddIssueModal}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        {/* Modal Content */}
        <form
          onSubmit={handleSubmit(onHandleAddIssue)}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4"
        >
          <div className="col-span-1">
            <label className="block text-sm font-medium text-primaryTextColor">
              Building Name <span className="text-red-500">*</span>
            </label>

            <select
              className={`mt-1 block w-full border ${
                errors.buildingName ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm outline-none p-2`}
              {...register("buildingName", { required: true })}
              onChange={(e) => {
                getFloors(e.target.value);
                setBuildingId(e.target.value);
                clearErrors("buildingName");
              }}
            >
              <option value="">Select Building</option>
              {building.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.nameBuilding}
                </option>
              ))}
            </select>
          </div>

          {/* Will be used later  for tanent side*/}
          {/* <div className="col-span-1">
            <label className="block text-sm font-medium text-primaryTextColor">
              Floor No <span className="text-red-500">*</span>
            </label>
            <select
              className={`mt-1 block w-full border ${
                errors.floorNo ? "border-red-500" : "border-gray-300"
              } rounded-md  outline-none shadow-sm p-2`}
              {...register("floorNo", { required: true })}
              onChange={(e) => {
                clearErrors("floorNo");
                getConfiguredRoomByBuilding(e.target.value);
              }}
            >
              <option value="">Select a floor</option>
              {floor.map((f, index) => (
                <option key={index} value={f.floorNumber}>
                  Floor-{f.floorNumber}
                </option>
              ))}
            </select>
          </div> */}

          {/* Will be used later  for tanent side*/}
          {/* <div className="col-span-1">
            <label className="block text-sm font-medium text-primaryTextColor">
              Room No <span className="text-red-500">*</span>
            </label>
            <select
              className={`mt-1 block w-full border ${
                errors.roomId ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm outline-none p-2`}
              {...register("roomId", { required: true })}
              onChange={(e) => {
                handleBed(e.target.value);
                clearErrors("roomId");
                // Logs the selected room object
              }}
            >
              <option value="">Select Room Number </option>
              {rooms.map((room, index) => (
                <option key={index} value={String(room._id)}>
                  R-F{floorNumber}
                  {String(room.roomNumber).padStart(3, "0")}
                </option>
              ))}
            </select>
          </div> */}
          <div>
            <label
              htmlFor="issueTitle"
              className="block text-sm font-medium text-gray-700"
            >
              Title
            </label>
            <input
              type="text"
              id="issueTitle"
              placeholder="Issue name"
              onChange={() => {
                clearErrors("issueTitle");
                // Logs the selected room object
              }}
              {...register("issueTitle", { required: true })}
              className={` border outline-none p-2 ${
                errors.issueTitle ? "border-red-500 " : "border-gray-300 "
              }mt-1  block  w-full   rounded-md shadow-sm sm:text-md`}
            />
          </div>

          <div>
            <label
              htmlFor="issueType"
              className="block text-sm font-medium text-gray-700"
            >
              Issue Type
            </label>
            <select
              id="issueType"
              name="issueType"
              {...register("issueType", { required: true })}
              className={` outline-none p-2   ${
                errors.issueType
                  ? " border border-red-500 "
                  : "border border-gray-300 "
              }mt-1   w-full  rounded-md  shadow-sm sm:text-md`}
              onChange={() => {
                clearErrors("issueType");
                // Logs the selected room object
              }}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="amenities">Amenities</option>
              <option value="food">Food</option>
              <option value="electrical">Electrical</option>
              <option value="plumbing">Plumbing</option>
              <option value="pests">Pests</option>
              <option value="cleaning">Cleaning</option>
              {/* <option value="bed">Bed</option> */}
              <option value="security">Security</option>
              <option value="power">Power</option>
              <option value="internet">Internet</option>
              <option value="miscellaneous">Miscellaneous</option>
            </select>
          </div>

          <div className="sm:col-span-2">
            <label
              htmlFor="issueDescription"
              className="block text-sm font-medium text-gray-700"
            >
              Issue
            </label>
            <textarea
              onChange={() => {
                clearErrors("issueDescription");
                // Logs the selected room object
              }}
              id="issueDescription"
              name="issueDescription"
              {...register("issueDescription", { required: true })}
              className={`  border ${
                errors.issueDescription ? "border-red-500" : "border-gray-300"
              } mt-1 p-4 block  w-full  rounded-md shadow-sm outline-none  sm:text-md`}
              placeholder="Write your issue here..."
            ></textarea>
          </div>

          {/* Buttons */}

          <div className="sm:col-span-2  flex justify-between gap-6 mt-6 tracking-wide">
            <button
              onClick={closeAddIssueModal}
              type="button"
              className="bg-white w-full border text-xs sm:text-lg hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primaryBtnColor text-xs sm:text-lg hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
            >
              {"Add Issue"}
            </button>
          </div>
        </form>
      </div>

      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
};

export default AddIssueModal;
